import PolarisIcon from '@/components/_common/PolarisIcon';
import { Box, Chip, Grid } from '@mui/material';
import { RefObject, useEffect, useRef } from 'react';
import { selectAssignedGroupsFilter, selectUserColumns } from '../../../redux/selectors/dataTableSelectors';
import { applyFilter, setSorting } from '../../../redux/slices/dataTableSlice';
import { UserGroup } from '../../../redux/slices/slice_types';
import GroupDisplay from './GroupDisplay';
import GroupSearch, { GroupSearchProps } from './GroupSearch';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';

export type GroupFilterProps = GroupSearchProps & {
  isTableFilter?: boolean;
};

const GroupFilter = ({ isTableFilter, ...props }: GroupFilterProps) => {
  const dispatch = useAppDispatch();
  const selectedGroups = useAppSelector(selectAssignedGroupsFilter);
  const tableColumns = useAppSelector(selectUserColumns);
  const filterRef = useRef<any>(null);

  useEffect(() => {
    (filterRef.current as RefObject<any>['current'])?.querySelector('input')?.focus();
  }, []);

  const applyGroupFilter = (e, selection: UserGroup) => {
    if (!selectedGroups.find((group: UserGroup) => group.id === selection.id)) {
      dispatch(applyFilter({ type: 'assigned_groups_filter', selections: [...selectedGroups, selection] }));
      const hasPriorityCol = tableColumns.find((col) => col.id === 'priority');
      hasPriorityCol && dispatch(setSorting({ id: 'priority', order: 'asc' }));
    }
  };

  const removeGroup = (id: number | string) => {
    const selections = selectedGroups.filter((group: UserGroup) => group.id !== id);
    dispatch(applyFilter({ type: 'assigned_groups_filter', selections }));
  };

  return (
    <Box sx={{ mt: 1, mb: 1, ml: 1, mr: 1 }}>
      <GroupSearch innerRef={filterRef} {...{ isTableFilter }} {...props} onSelect={applyGroupFilter as any} />

      {selectedGroups.length > 0 && (
        <Grid container flexDirection="column" alignItems="flex-start" sx={{ mt: 3 }}>
          {selectedGroups.map((group: UserGroup) => (
            <Chip
              key={group.id}
              label={<GroupDisplay group={group} />}
              onDelete={() => removeGroup(group.id)}
              sx={{ mb: 1 }}
              deleteIcon={<PolarisIcon icon="close" />}
            />
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default GroupFilter;
